import { API_URL } from 'src/constants';
import { fetch } from '../fetchWrapper/fetch';
import { IUser } from 'src/types';

export const updateUser = async (user: Partial<IUser>): Promise<void> => {
  const uri = `${API_URL}/admin/users/${user.id}`;

  try {
    const response = await fetch(uri, {
      method: 'PATCH',
      body: JSON.stringify({ role: user.role, brands: user.brands }),
    });
    if (!response.ok) {
      throw new Error('Unknown issue, please try again later.');
    }
  } catch (e) {
    throw new Error(e.message);
  }
};
